import { render, staticRenderFns } from "./date-input.generic.vue?vue&type=template&id=048d7557&"
import script from "./date-input.generic.vue?vue&type=script&lang=js&"
export * from "./date-input.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports